var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import styles from './style.module.css';
import { Checkbox } from '../../../Components/BaseComponents/Checkbox';
import { InfoIcon } from './InfoIcon';
import { InformationModal } from './InformationModal';
export function ZeroIdAgreement(_a) {
    var enabled = _a.enabled, onCheck = _a.onCheck;
    var _b = React.useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    return (_jsxs(_Fragment, { children: [_jsx(InformationModal, { label: "Swipelux ZeroId", isOpen: isModalOpen, onClose: function () { return setIsModalOpen(false); } }), _jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsx(Checkbox, __assign({ onChange: onCheck, checked: enabled }, { children: "Save my verification to ZeroID" })), _jsx(InfoIcon, { onClick: function () { return setIsModalOpen(true); } })] }))] }));
}
